export default __webpack_public_path__ + "static/media/buttonOff.04b5431a.png";